import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CianUnionModal from './CianUnionModal';

class CianUnion extends React.Component {
  constructor (props) {
    super(props);

    const timerByClick = 10;
    // isOpenModal активен при включенной куке unionCianModal
    const isAutoNotOmsk = props.isOpenModal && props.regionId !== 55 ? 20 : timerByClick;
    const timer = props.isOpenModal && props.regionId === 55 ? null : isAutoNotOmsk;
    this.state = {
      openedModal: props.isOpenModal || false,
      timer: timer
    };

    this.onClickModalControl = this.onClickModalControl.bind(this);
  }

  onClickModalControl () {
    this.setState({
      openedModal: true
    });
  }

  renderModal () {
    const { openedModal, timer } = this.state;
    const { cianModalContext } = this.props;
    return (
      <CianUnionModal
        visible={openedModal}
        onClose={() => this.setState({openedModal: false})}
        timer={timer}
        cianModalContext={cianModalContext}
      />
    );
  }

  render () {
    return (
      <Fragment>
        { this.props.children !== null &&
          <span onClick={this.onClickModalControl}>
            { this.props.children }
          </span>
        }

        { this.state.openedModal && this.renderModal() }
      </Fragment>
    );
  }
}

CianUnion.propTypes = {
  regionId: PropTypes.number,
  children: PropTypes.any.isRequired,
  isOpenModal: PropTypes.bool,
  cianModalContext: PropTypes.any.isRequired
};

CianUnion.defaultProps = {
  regionId: null,
  children: null,
  isOpenModal: null
};

function mapStateToProps (state) {
  return {
    regionId: state.getIn(['domain', 'regionId']),
    cianModalContext: state.getIn(['home', 'cian_modal_context'], { is_visible: false }).toJS()
  };
}

export default connect(mapStateToProps)(CianUnion);



// WEBPACK FOOTER //
// ./src/ui/CianUnion/CianUnion.jsx